import ReactGA from "react-ga";
import { datadogRum } from "@datadog/browser-rum";
import { CustomDimensions } from "monitoring";

export const trackInterest = (
  insightName: string,
  category: string = "PriorityInsights",
  locationScope?: string,
  timePeriod?: string
) => () => {
  ReactGA.ga("send", "event", category, "Clicked", insightName, {
    [CustomDimensions.location_scope]: locationScope,
    [CustomDimensions.time_period]: timePeriod,
    nonInteraction: false
  });
  datadogRum.addUserAction("PriorityInsightClicked", {
    insightName,
    category
  });
};
